import React, {Component} from 'react';
import assets from "../../../util/assets";
import {Button, Col, Row, TabContent, TabPane} from "reactstrap";
import "./index.css";
import "../common.css";
import {isEmpty, LogException, vuepayAlert, vuePayLog} from "../../../util/utility";
import {TabComponent} from "./index";
import RequestSearchComponent from "../../RequestSearchComponent/RequestSearchComponent";
import OneonOneRequests from "../../OneonOneRequests/OneonOneRequests";
import * as actions from "../../../actions";
import {connect} from "react-redux";
import {getData, LOGIN, setData} from "../../../util/storage";
import {decodeEncryptedIdForBroadcaster, getEncryptedIdForBroadcaster} from "../../../util/broadcast_util";
import {getBroadcastID} from "../../../util/broadcast/start_broadcast";
import {updateJWTToken} from "../../../util/broadcast/create";
import {acceptPaidGroupRequest, updateAvailabilityRequestUser} from "../../../util/firebase/firestore";
import GroupRequests from "../../GroupRequests/GroupRequests";
import share from "../../../util/share";
import {canBroadcasterAcceptOrSendInvite} from "../../../util/business_logic";
import {acceptUserRequestAndCreateNewBroadcast} from "../../../util/broadcast/one_to_one_request";
import GroupRequest from "../../broadcast/GroupRequest";

const getNumberOfCount = (requestList) => {
    let countData = requestList.filter((request) => {
        return request.status === 0;
    });
    return countData.length;
};

const getRequestCount = (availability, type) => {

    if (availability && availability.groupAvailabilityList && type === "group") {
        return getNumberOfCount(availability.groupAvailabilityList)
    } else if (availability && availability.oneToOneAvailabilityList && type === "onetoone") {
        return getNumberOfCount(availability.oneToOneAvailabilityList)
    } else {
        return 0;
    }
};

const screename = "RequestComponent";

class RequestComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: "onetoone",
            isChecked: null,
            selectAllCheckbox: false,
            checkboxStore: [],
            oneToOneRequests: 0,
            groupRequests: 0,
            req_id: null,
            broadcasterRequestId: null,
            broadcasterRequestIds: [],
            broadcasterType: null,
            favUserId: null,
            blockUserId: null,
            sessionType: null,
            broadcast: null,
            viewerAcceptedPrivateRequest: false,
            getOneToOneSearchValue: "",
            getGroupSearchValue: "",
            searchedOneToOneData: [],
            searchedOneToOneDataStatus: false,
            searchedGroupData: [],
            searchedGroupDataStatus: false,
            viewer: null,
            isSubscribed: false,
            shareList: share.listArray,
            isBroadcasterSettingGroupPrice:false
        }
    }

    componentDidMount() {

    }

    componentDidUpdate(nextProps) {
        /**
         * Since the activeTab is controlled from props we need to check if their is UI update we need to update the
         * internal tab state
         */
        const {activeRightLayout} = this.props
        if (nextProps.activeRightLayout !== activeRightLayout) {
            if (activeRightLayout) {
                this.setState({
                    activeTab: activeRightLayout
                },()=>{
                    if(this.state.activeTab === "group"){
                        this.setBroadcasterSettingGroupPrice(false)
                    }
                })
            }
        }
    }

    setBroadcasterSettingGroupPrice = (value)=>{
        this.setState({
            isBroadcasterSettingGroupPrice: value
        })
    };

    toggleBroadcasterSettingGroupPrice = ()=>{
        this.setState({
            isBroadcasterSettingGroupPrice: !this.state.isBroadcasterSettingGroupPrice
        })
    };

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (
            nextProps &&
            nextProps.availability &&
            nextProps.availability.favoriteUserSuccess
        ) {
            updateAvailabilityRequestUser(
                this.state.favUserId,
                this.getBroadcastId(),
                this.state.sessionType,
                "favorite",
                true,
                (jsonData) => {
                    this.state.sessionType === "group"
                        ? jsonData &&
                        jsonData.length > 0 &&
                        this.setState({
                            groupRequests: jsonData && jsonData.length > 0 && jsonData,
                        })
                        : jsonData &&
                        jsonData.length > 0 &&
                        this.setState({
                            oneToOneRequests: jsonData && jsonData.length > 0 && jsonData,
                        });
                }
            );
            this.props.resetFavouriteUser();
        }

        if (
            nextProps &&
            nextProps.availability &&
            nextProps.availability.unFavoriteUserSuccess
        ) {
            updateAvailabilityRequestUser(
                this.state.favUserId,
                this.getBroadcastId,
                this.state.sessionType,
                "favorite",
                false,
                (jsonData) => {
                    this.state.sessionType === "group"
                        ? this.setState({
                            groupRequests: jsonData && jsonData,
                        })
                        : this.setState({
                            oneToOneRequests: jsonData && jsonData,
                        });
                }
            );
            this.props.resetFavouriteUser();
        }

        if (
            nextProps &&
            nextProps.availability &&
            nextProps.availability.removeAvailabilityUserRequestSuccess
        ) {
            updateAvailabilityRequestUser(
                this.state.favUserId,
                this.getBroadcastId(),
                this.state.sessionType,
                "remove",
                2,
                (jsonData) => {
                    this.state.sessionType === "group"
                        ? this.setState({
                            groupRequests: jsonData && jsonData,
                        })
                        : this.setState({
                            oneToOneRequests: jsonData && jsonData,
                        });
                }
            );
            this.props.resetRemoveUserRequest();
        }
        if (
            nextProps &&
            nextProps.availability &&
            nextProps.availability.blockUserSuccess
        ) {
            updateAvailabilityRequestUser(
                this.state.blockUserId,
                this.getBroadcastId(),
                this.state.sessionType,
                "block",
                2,
                (jsonData) => {
                    this.state.sessionType === "group"
                        ? this.setState({
                            groupRequests: jsonData && jsonData,
                        })
                        : this.setState({
                            oneToOneRequests: jsonData && jsonData,
                        });
                }
            );
            this.props.resetBlockUser();
        }

        if (nextProps && nextProps.availability &&
            nextProps.availability.broadcasterAcceptRequestSuccess
        ) {

            this.props.resetbroadcasterAcceptRequest();

            if (nextProps.availability.broadcasterAcceptRequest &&
                nextProps.availability.broadcasterAcceptRequest.error &&
                nextProps.availability.broadcasterAcceptRequest.error.status_code === 400
            ) {
                vuepayAlert(
                    "error",
                    nextProps.availability.broadcasterAcceptRequest.error.message
                );
            } else {

                vuepayAlert(
                    "success",
                    nextProps.availability.broadcasterAcceptRequest.success.message
                );
                if (this.state.broadcasterType !== "group") {
                    //private request was accepted
                    getData(LOGIN).then((data) => {
                        if (!isEmpty(data)) {

                            this.props.setInteractedViewerID(this.state.viewer.user_id)

                            const jsonData = {
                                device: this.props.device,
                                broadcast_id:this.getBroadcastId(),
                            };
                            this.props.createPrivateBroadcast(
                                data.token,
                                data.api_token,
                                jsonData
                            );
                        }
                    });
                } else if (this.state.broadcasterType === "group") {

                    //check if all the props passed through browser is valid and must consist of  broadcast_id, session_id, token
                    getBroadcastID(this.props.location)
                        .then((broadcastDetail) => {



                            const payload = nextProps.availability.broadcasterAcceptRequest.success;
                            const broadcastID = broadcastDetail.broadcast_id;
                            const sessionID = nextProps.availability.broadcasterAcceptRequest.success.data.session_id;
                            const token = nextProps.availability.broadcasterAcceptRequest.success.data.token;
                            const jwt_token = nextProps.availability.broadcasterAcceptRequest.success.data.jwt_token;
                            const availability_id = getEncryptedIdForBroadcaster(this.props.account_management.userDetails.broadcaster[0].availability[0].id);

                            updateJWTToken(payload, () => {


                                // add paid group node in firestore
                                let _broadcastId = decodeEncryptedIdForBroadcaster(broadcastID);
                                acceptPaidGroupRequest(_broadcastId,_broadcastId, {price: this.props.initialValues.group_session_price}, () => {

                                    let data = {
                                        id:_broadcastId,
                                        session_id:sessionID,
                                        token:token
                                    };
                                    this.props.disconnectFromTokBoxAndChangeBroadcast(data)
                                })

                            });
                        })
                        .catch((err) => {
                            LogException("BroadcastAvailabilityRequests", "checkValidBroadcast", err);
                            vuepayAlert("error", "Sorry we didn't recognise the broadcast details and have to navigate you out of it, please try again later.");
                        });

                }
            }
        }

        /*------------START SESSION--------------*/

        if (
            nextProps.broadcast &&
            nextProps.broadcast.private_broadcast_payload != null
        ) {
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    setData(LOGIN, {
                        ...data,
                        token: nextProps.broadcast.private_broadcast_payload.data.token,
                    });
                }
            });

            //check if all the props passed through browser is valid and must consist of  broadcast_id, session_id, token
            getBroadcastID(this.props.location)
                .then((broadcastDetail) => {
                    const payload = nextProps.broadcast.private_broadcast_payload;
                    const broadcastID = broadcastDetail.broadcast_id;
                    const sessionID = nextProps.broadcast.private_broadcast_payload.data.session_id;
                    const token = nextProps.broadcast.private_broadcast_payload.data.token;
                    const jwt_token = nextProps.broadcast.private_broadcast_payload.data.jwt_token;
                    const private_broadcast_id = nextProps.broadcast.private_broadcast_payload.data.id;
                    const availability_id = getEncryptedIdForBroadcaster(this.props.account_management.userDetails.broadcaster[0].availability[0].id);
                    updateJWTToken(payload, () => {
                        const path = `/broadcaster/start/broadcast?session_id=${sessionID}&broadcast_id=${broadcastID}&token=${token}&private_broadcast_id=${getEncryptedIdForBroadcaster(private_broadcast_id)}&availability=true&availability_id=${availability_id}`;

                        this.props.history.push(path, {
                            session_id: sessionID,
                            jwt_token: jwt_token,
                            broadcast_id: broadcastID,
                            token: token,
                            requestId: this.state.broadcasterRequestId,
                            viewerProfile: this.state.viewer,
                            requestType: "onetoone",
                        });

                        this.props.resetBroadcastDetail();

                        window.location.href = path;
                    });


                })
                .catch((err) => {
                    LogException("BroadcastAvailabilityRequests", "checkValidBroadcast", err);
                    vuepayAlert("error", "Sorry we didn't recognise the broadcast details and have to navigate you out of it, please try again later.");
                });
        }

        /*--------------------------*/

    }

    privateSessionUpdate = (querySnapshot) => {
        let privateRequest = [];
        querySnapshot.forEach((doc) => {
            privateRequest.push(doc.data());
        });

        this.props.updatePrivateAvailabilityList(
            privateRequest && privateRequest
        );
    };


    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                favUserId: null,
                blockUserId: null,
                sessionType: null,
            }, () => {
                this.props.setRightLayout(tab);
            });
        }
    };

    // Handle Search data
    onSearchChange = (e, target, value, _list, _filteredlist, _found) => {

        const obj = {};
        let list, filteredlist, found;

        if (e) {
            target = e.target.name;
            value = e.target.value;
            list = e.target.getAttribute("data-list");
            filteredlist = e.target.getAttribute("data-filterlist");
            found = e.target.getAttribute("data-found");
        } else {
            list = _list;
            filteredlist = _filteredlist;
            found = _found;
        }
        obj[target] = value;

        this.setState(obj, () => {
            this.filterList(this.state[target], list, filteredlist, found)
        });
    };

    filterList = (value, list, filteredlist, found) => {
        const requestList = this.props.availability[list];
        const result = requestList.filter(request => request.username.toLowerCase().indexOf(value.toLowerCase().trim()) >= 0);

        const obj = {};
        obj[filteredlist] = result;
        obj[found] = result.length === 0;
        this.setState(obj)
    };

    acceptPrivateRequestAndCreateNewBroadcast = (viewer_id) => {
        if (canBroadcasterAcceptOrSendInvite(this.props.oneToOneRequestArray)) {
            acceptUserRequestAndCreateNewBroadcast(this.props, viewer_id, (formData) => {
                this.setState({
                    formData: formData,
                    viewer_id: this.state.viewer.user_id,
                    isFetching: true
                }, () => {
                    this.props.setInteractedViewerID(this.state.viewer.user_id)
                });
            })
        } else {
            //open the error modal
            this.props.toggleCommonModal();
        }

    }
    submitBroadcasterAcceptRequest = (actionType) => {
        this.setState({
            broadcasterType: actionType,
        });

        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                let acceptData;
                if (actionType === "onetoone") {
                    acceptData = {
                        request_id: this.state.broadcasterRequestId,
                        request_ids: this.state.broadcasterRequestIds,
                        request_type: this.state.broadcasterType,
                    };
                } else {
                    acceptData = {
                        request_id: null,
                        request_ids: this.state.checkboxStore,
                        request_type: actionType,
                    };
                }

                vuePayLog(screename,"submitBroadcasterAcceptRequest >> acceptData",{
                    ...acceptData,
                    actionType
                });
                this.props.broadcasterAcceptRequest(
                    data.token,
                    data.api_token,
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].id,
                    acceptData
                );
            }
        });
    };

    broadcasterAcceptRequestData = (id, type) => {
        let viewer = this.props.availability.oneToOneAvailabilityList.filter(
            (req) => req.id === id
        );

        this.setState({
            viewer: viewer[0],
            broadcasterRequestId: viewer[0].request_id ? viewer[0].request_id : viewer[0].id,
            broadcasterRequestIds: [],
            broadcasterType: type,
        }, () => {
            vuePayLog(screename, "broadcasterAcceptRequestData", {
                viewer: this.state.viewer,
                broadcasterRequestId: this.state.broadcasterRequestId,
                broadcasterRequestIds: this.state.broadcasterRequestIds,
                broadcasterType: this.state.broadcasterType,
            })
        });
    };

    // Select radio style and hook
    radioToggle = (event) => {
        this.setState({
            isChecked: event.target.value,
        });
    };

    selectAllToggle = () => {
        this.setState({
            selectAllCheckbox: !this.state.selectAllCheckbox,
            checkboxStore: []
        }, () => {
            if (this.state.selectAllCheckbox) {
                let requestIds = [];
                this.props.availability.groupAvailabilityList.map((request) => {
                    requestIds.push(request.id);
                });

                this.setState({
                    checkboxStore: requestIds
                })
            }
        });
    };

    checkboxToggle = (event) => {
        const stringToIntValue = parseInt(event.target.value);

        let checkboxStore = this.state.checkboxStore;
        let present = checkboxStore.includes(stringToIntValue);
        if (present) {
            //remove and update the state
            checkboxStore = checkboxStore.filter((id) => {
                return id !== stringToIntValue
            });

            this.setState({
                selectAllCheckbox: !present && this.state.selectAllCheckbox
            });
        } else {
            //please add into the array
            checkboxStore.push(stringToIntValue)
        }

        this.setState({
            checkboxStore,
        });

    };

    favoriteUserById = (id, type) => {
        this.setState({
            favUserId: id,
            sessionType: type,
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.favouriteUser(
                    data.token,
                    data.api_token,
                    id,
                    this.getBroadcastId()
                );
            }
        });
    };

    getBroadcastId = ()=>{
        let broadcast_id = -1;
        if(this.props.hasOwnProperty("initialValues") && this.props.initialValues.hasOwnProperty("id")){
            broadcast_id = this.props.initialValues.id
        }else{
            broadcast_id = this.props.account_management &&
                this.props.account_management.userDetails &&
                this.props.account_management.userDetails.broadcaster.length > 0 &&
                this.props.account_management.userDetails.broadcaster[0]
                    .availability[0].broadcast[0].id
        }

        return broadcast_id;
    }

    unFavoriteUserById = (id, type) => {
        this.setState({
            favUserId: id,
            sessionType: type,
        });


        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.unFavouriteUser(
                    data.token,
                    data.api_token,
                    id,
                    this.getBroadcastId()
                );
            }
        });
    };

    blockUserById = (id, type) => {
        this.setState({
            blockUserId: id,
            sessionType: type,
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.blockUser(data.token, data.api_token, id);
            }
        });
    };

    unBlockUserById = (id, type) => {
        this.setState({
            blockUserId: id,
            sessionType: type,
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.unBlockUser(data.token, data.api_token, id);
            }
        });
    };

    removeUserRequestByReqId = (req_id, type, user_id) => {
        this.setState({
            req_id: req_id,
            sessionType: type,
            favUserId: user_id
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.removeUserRequest(
                    data.token,
                    data.api_token,
                    req_id,
                    this.getBroadcastId()
                );
            }
        });
    };

    render() {

        const onetooneRequestCount = getRequestCount(this.props.availability, "onetoone");
        const groupRequestCount = getRequestCount(this.props.availability, "group");

        return (
            <div className="chat-component-container">
                <Row className="chat-component-header-container">
                    <Col className="chat-component-header">Requests</Col>
                    <Col className="chat-component-header-close">
                        <img src={assets.broadcast.cross}
                             onClick={() => {
                                 vuePayLog("RequestComponent", "", "Cross icon clicked");
                                 this.props.setRightLayout("");
                             }}
                             alt="cross icon"
                             width={13}/>
                    </Col>
                </Row>
                <div className="chat-component-header-divider "/>

                <TabComponent
                    activeTab={this.state.activeTab}
                    oneToOneRequestCount={onetooneRequestCount}
                    groupRequestCount={groupRequestCount}
                    toggle={this.toggle}/>

                <TabContent activeTab={this.state.activeTab} >
                    <TabPane tabId="onetoone">
                        <RequestSearchComponent
                            name={"getOneToOneSearchValue"}
                            list={"oneToOneAvailabilityList"}
                            filterList={"searchedOneToOneData"}
                            found={"searchedOneToOneDataStatus"}
                            requestCount={onetooneRequestCount}
                            searchValue={this.state.getOneToOneSearchValue}
                            clearSearch={() => {
                                const list = "oneToOneAvailabilityList",
                                    filteredlist = "searchedOneToOneData",
                                    found = "searchedOneToOneDataStatus";
                                this.onSearchChange(null, "getOneToOneSearchValue", "", list, filteredlist, found)
                            }}
                            updateSearchValue={this.onSearchChange}
                            searchRequest={() => {
                                const list = "oneToOneAvailabilityList",
                                    filteredlist = "searchedOneToOneData",
                                    found = "searchedOneToOneDataStatus";
                                this.filterList(this.state.getOneToOneSearchValue, list, filteredlist, found)
                            }}
                            video={true}
                        />

                        <Row className="mx-0">
                            <Col sm="12" className="px-0">
                                <Row className="mx-0">
                                    <OneonOneRequests
                                        availability={this.props.availability}
                                        submitBroadcasterAcceptRequest={this.submitBroadcasterAcceptRequest}
                                        searchStatus={this.state.searchedOneToOneDataStatus}
                                        searchData={this.state.searchedOneToOneData}
                                        requestCount={onetooneRequestCount}
                                        requests={this.props.availability.oneToOneAvailabilityList}
                                        requestMessage={"has requested a 1-on-1 session"}
                                        shareList={this.state.shareList}
                                        isChecked={this.state.isChecked}
                                        radioToggle={this.radioToggle}
                                        favoriteUserById={this.favoriteUserById}
                                        unFavoriteUserById={this.unFavoriteUserById}
                                        blockUserById={this.blockUserById}
                                        removeUserRequestByReqId={this.removeUserRequestByReqId}
                                        broadcasterAcceptRequestData={this.broadcasterAcceptRequestData}
                                        video={true}
                                    />
                                </Row>
                            </Col>
                        </Row>

                        <Row className="request-button-container">
                            {
                                onetooneRequestCount > 0 && (
                                    <Col md="12" sm="12" className="text-center">
                                        <Button
                                            color="primary"
                                            className="request-button"
                                            onClick={() => {
                                                if (this.props.availabilityID === -1) {
                                                    this.acceptPrivateRequestAndCreateNewBroadcast(this.state.broadcasterRequestId)
                                                } else {
                                                    this.submitBroadcasterAcceptRequest("onetoone")
                                                }
                                            }}
                                            disabled={!this.state.isChecked}
                                        >
                                            {this.props.availability.isFetching || this.state.isFetching ? (
                                                <img
                                                    src={assets.loading_white}
                                                    alt={"Loading"}
                                                    width={26}
                                                    height={26}
                                                />
                                            ) : (
                                                "ACCEPT 1-ON-1 REQUEST"
                                            )}
                                        </Button>
                                    </Col>
                                )
                            }
                        </Row>
                    </TabPane>
                    <TabPane tabId="group">

                        {
                            !this.state.isBroadcasterSettingGroupPrice &&
                            <RequestSearchComponent
                                name={"getGroupSearchValue"}
                                list={"groupAvailabilityList"}
                                filterList={"searchedGroupData"}
                                found={"searchedGroupDataStatus"}
                                requestCount={groupRequestCount}
                                searchValue={this.state.getGroupSearchValue}
                                clearSearch={() => {
                                    const list = "groupAvailabilityList",
                                        filteredlist = "searchedGroupData",
                                        found = "searchedGroupDataStatus";
                                    this.onSearchChange(null, "getGroupSearchValue", "", list, filteredlist, found)
                                }}
                                updateSearchValue={this.onSearchChange}
                                searchRequest={() => {
                                    const list = "groupAvailabilityList",
                                        filteredlist = "searchedGroupData",
                                        found = "searchedGroupDataStatus";
                                    this.filterList(this.state.getGroupSearchValue, list, filteredlist, found)
                                }}
                                video={true}
                            />
                        }


                        <Row className="mx-0">
                            <Col sm="12" className="px-0 full-width">
                                <Row className="mx-0">
                                    {
                                        !this.state.isBroadcasterSettingGroupPrice ?
                                            <GroupRequests
                                                initialValues={this.props.initialValues}
                                                selectAllCheckbox={this.state.selectAllCheckbox}
                                                selectAllToggle={this.selectAllToggle}
                                                checkboxStore={this.state.checkboxStore}
                                                availability={this.props.availability}
                                                submitBroadcasterAcceptRequest={this.submitBroadcasterAcceptRequest}
                                                searchStatus={this.state.searchedGroupDataStatus}
                                                searchData={this.state.searchedGroupData}
                                                requestCount={groupRequestCount}
                                                requests={this.props.availability.groupAvailabilityList}
                                                requestMessage={"has requested a group session"}
                                                shareList={this.state.shareList}
                                                isChecked={this.state.isChecked}
                                                checkboxToggle={this.checkboxToggle}
                                                favoriteUserById={this.favoriteUserById}
                                                unFavoriteUserById={this.unFavoriteUserById}
                                                blockUserById={this.blockUserById}
                                                removeUserRequestByReqId={this.removeUserRequestByReqId}
                                                broadcasterAcceptRequestData={this.broadcasterAcceptRequestData}
                                                video={true}
                                            />
                                            :
                                            <GroupRequest
                                                initialValues={this.props.initialValues}
                                                broadcast={this.props.broadcast}
                                                groupRequestArray={this.props.groupRequestArray}
                                                disconnectFromTokBoxAndChangeBroadcast={
                                                    this.props.disconnectFromTokBoxAndChangeBroadcast
                                                }
                                                availabilityID={this.props.availabilityID}
                                                updateBroadcasterType={this.props.updateBroadcasterType}
                                            />

                                    }

                                </Row>
                            </Col>
                        </Row>

                        <Row className="request-button-container">
                            {
                                !this.state.isBroadcasterSettingGroupPrice && groupRequestCount > 0 && (
                                    <Col md="12" sm="12" className="text-center">
                                        <Button
                                            color="primary"
                                            className="request-button"

                                            onClick={() => {
                                                if (this.props.availabilityID === -1) {
                                                    this.toggleBroadcasterSettingGroupPrice()
                                                } else {
                                                    this.submitBroadcasterAcceptRequest("group");
                                                }
                                            }
                                            }
                                            disabled={this.state.checkboxStore.length === 0}
                                        >
                                            {this.props.availability.isFetching ? (
                                                <img
                                                    src={assets.loading_white}
                                                    alt={"Loading"}
                                                    width={26}
                                                    height={26}
                                                />
                                            ) : (
                                                "START GROUP SESSION"
                                            )}
                                        </Button>
                                    </Col>
                                )
                            }
                        </Row>

                    </TabPane>
                </TabContent>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        account_management: state.account_management,
        availability: state.availability,
        broadcast: state.broadcast,
        get_broadcast_earnings: state.get_broadcast_earnings,
        broadcaster_detail_management: state.broadcaster_detail_management,
        broadcaster_favourites: state.broadcaster_favourites,
        broadcaster_block_unblock_viewer: state.broadcaster_block_unblock_viewer,
        device: state.device.payload,
    };
}

export default connect(mapStateToProps, actions)(RequestComponent);

